import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PageCarousel } from './components/PageCarousel';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Audience } from './components/Audience';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Alongside } from './components/Alongside';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// import { PurchaseNotifications } from './components/PurchaseNotifications'
// Mount <PurchaseNotifications /> again once data/recentPurchases.ts is fed by real orders.

export function App() {
  return <div className="min-h-screen w-full bg-field font-sans text-cream selection:bg-willow selection:text-willow-ink" data-id="element-0" data-mp="3rd18nfm3z7mg">
      <MetaPixel data-id="element-1" data-mp="7stte3h7l4p" />
      <main data-id="element-2" data-mp="2zld1r8m3ndb0">
        <Hero data-id="element-3" data-mp="2zlv7cvunj3vl" />
        <SocialProofBar data-id="element-4" data-mp="2zm4vedw4z0yn" />
        <PainGrid data-id="element-5" data-mp="2zmwhmy3ufmc9" />
        <ProductReveal data-id="element-6" data-mp="2zng1wlgyumtg" />
        <Tomes data-id="element-7" data-mp="33m5a7zn5de68" />
        <PageCarousel data-id="element-8" data-mp="33nq5xsl7735o" />
        <Bonuses data-id="element-9" data-mp="33n6xd2hftr4b" />
        <ValueStack data-id="element-10" data-mp="33orki71fa7s5" />
        <Urgency data-id="element-11" data-mp="38lrs4mdx7ild" />
        <Pricing data-id="element-12" data-mp="38l8f9k34nke7" />
        {/* Real reviews replace "Who it's for" as soon as data/testimonials.ts has entries */}
        {shortTestimonials.length > 0 ? <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="dark" data-id="element-13" data-mp="3dirxsw6uyjby" /> : <Audience data-id="element-14" data-mp="sunbk38ws6eh" />}
        <Guarantee data-id="element-15" data-mp="stub1k0jmd4s" />
        <Faq data-id="element-16" data-mp="st2heeqiaph5" />
        {moreTestimonials.length > 0 ? <Testimonials testimonials={moreTestimonials} title="Works alongside your club" subtitle="Club coaches use it to turn the drills they already have into a full session." background="mid" data-id="element-17" data-mp="3688rpx40wyp" /> : <Alongside data-id="element-18" data-mp="d2bibguajxvo" />}
        <CostOfInaction data-id="element-19" data-mp="851lhg4kojxt" />
        <Close data-id="element-20" data-mp="86w6svjrae2f" />
      </main>
      <Footer data-id="element-21" data-mp="83i39jzcvyte" />
    </div>;
}